import * as THREE from "three";

export const LOOM_ACTIVE_OUTLINE_ROLE = "active-part-outline" as const;
export const LOOM_ACTIVE_OUTLINE_DEPTH_POLICY = "depth-tested-opaque-occlusion" as const;

export function addLoomSelectionOutlines(
  scene: THREE.Group,
  color: string,
): number {
  const selectedMeshes: THREE.Mesh<THREE.BufferGeometry>[] = [];
  scene.traverse((object) => {
    const mesh = object as THREE.Mesh<THREE.BufferGeometry>;
    if (mesh.isMesh && mesh.userData.loomActiveSelection === true) selectedMeshes.push(mesh);
  });
  selectedMeshes.forEach((mesh) => {
    const outline = new THREE.LineSegments(
      new THREE.EdgesGeometry(mesh.geometry, 18),
      new THREE.LineBasicMaterial({
        color,
        depthTest: true,
        depthWrite: false,
        opacity: 0.96,
        toneMapped: false,
        transparent: true,
      }),
    );
    outline.name = `Active part outline: ${mesh.userData.loomEditableNodeId as string}`;
    outline.raycast = () => undefined;
    outline.renderOrder = 40;
    outline.userData.loomActiveOutlineNodeId = mesh.userData.loomEditableNodeId;
    outline.userData.loomVisualRole = LOOM_ACTIVE_OUTLINE_ROLE;
    mesh.add(outline);
  });
  scene.userData.loomActiveOutlineCount = selectedMeshes.length;
  scene.userData.loomActiveOutlineDepthPolicy = LOOM_ACTIVE_OUTLINE_DEPTH_POLICY;
  return selectedMeshes.length;
}
